
            const data = {"name":"ic_search","data":{"width":"11","height":"11","viewBox":"0 0 11 11","data":"<path pid=\"0\" d=\"M10 9.692L7.825 7.71M9 5.134C9 7.148 7.21 8.78 5 8.78S1 7.148 1 5.134s1.79-3.647 4-3.647S9 3.12 9 5.134z\" _stroke=\"#979797\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#979797"}],"stopColors":[]}}
        
                module.exports = data
                